import { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router';
import { House, Wrench, CalendarCheck } from '@phosphor-icons/react';
import { HStack, VStack } from '@astryxdesign/core/Stack';
import { Text } from '@astryxdesign/core/Text';
import { Icon } from '@astryxdesign/core/Icon';
import { attachLiquidGlass } from './glass';

const ITEMS = [
  { to: '/', label: 'Главная', icon: House, end: true },
  { to: '/services', label: 'Услуги', icon: Wrench, end: false },
  { to: '/my', label: 'Моя запись', icon: CalendarCheck, end: false },
] as const;

/**
 * Fixed glass tab bar. The page reserves its height (+ safe area) with
 * `.pb-nav`, so it never covers content.
 */
export function BottomNav() {
  const { pathname } = useLocation();

  useEffect(() => {
    let dispose = () => {};
    let cancelled = false;
    // re-snapshot after each navigation so the refraction matches the page
    const t = window.setTimeout(() => {
      void attachLiquidGlass('.sgx-bottom-nav', { zIndex: 40 }).then((d) => {
        if (cancelled) d();
        else dispose = d;
      });
    }, 400);
    return () => {
      cancelled = true;
      window.clearTimeout(t);
      dispose();
    };
  }, [pathname]);

  return (
    <nav
      aria-label="Разделы"
      className="sgx-bottom-nav glass fixed inset-x-3 z-40 mx-auto max-w-md rounded-full safe-bottom-offset"
    >
      <HStack hAlign="around" vAlign="center" paddingBlock={1} paddingInline={2}>
        {ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className="glass-label group flex min-h-12 min-w-20 items-center justify-center rounded-full px-3 py-1 transition-colors duration-200 aria-[current=page]:bg-accent-muted focus-visible:outline-2"
          >
            {({ isActive }) => (
              <VStack gap={0.5} hAlign="center">
                <Icon icon={item.icon} size="md" color={isActive ? 'accent' : 'secondary'} />
                <Text type="label" size="xsm" color={isActive ? 'primary' : 'secondary'} weight={isActive ? 'semibold' : 'medium'}>
                  {item.label}
                </Text>
              </VStack>
            )}
          </NavLink>
        ))}
      </HStack>
    </nav>
  );
}
